var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    { staticClass: "download-list-item download-list-item--unapproved" },
    [
      _c(
        "div",
        {
          staticClass:
            "download-list-item__icon download-list-item__icon--primary",
        },
        [_c("i", { staticClass: "fa fa-2x", class: _vm.getFileIcon })]
      ),
      _vm._v(" "),
      this.is_offer
        ? _c("div", { staticClass: "download-list-item__block" }, [
            _c("p", { staticClass: "download-list-item__label" }, [
              _vm._v("\n      " + _vm._s(_vm.file.file_name) + "\n    "),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "download-list-item__link" }, [
              _c("span", { on: { click: this.handleDownloadFileCallback } }, [
                _c("i", { staticClass: "fa fa-cloud-download" }),
                _vm._v(" Download File\n      "),
              ]),
            ]),
          ])
        : _c("div", { staticClass: "download-list-item__block" }, [
            _c("p", { staticClass: "download-list-item__label" }, [
              _vm._v("\n      " + _vm._s(_vm.file.name) + "\n      "),
              _c(
                "span",
                { staticClass: "download-list-item__label--unapproved" },
                [
                  _vm._v(
                    " - " +
                      _vm._s(
                        _vm._f("date")(
                          _vm.fileLastUpdated,
                          _vm.$user.date_format_preference
                        )
                      )
                  ),
                ]
              ),
            ]),
          ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "download-list-item__icon download-list-item__icon--secondary items-center",
        },
        [
          _c("i", {
            staticClass: "fa fa-times",
            on: { click: this.handleDeleteFileCallback },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }